import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import DeviceSensor from './device-sensor';
import DeviceSensorDeleteDialog from './device-sensor-delete-dialog';
import DeviceSensorDetail from './device-sensor-detail';
import DeviceSensorUpdate from './device-sensor-update';



const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={DeviceSensorUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={DeviceSensorUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id`} component={DeviceSensorDetail} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute path={match.url} component={DeviceSensor} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={DeviceSensorDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
